export default __webpack_public_path__ + "static/media/ls-flower-half.31eb5e36.png";